class GoogleOptimizeExperimentData {
  private readonly _name: string;
  private readonly _patternName: string;

  constructor(name: string, patternName: string) {
    this._name = name;
    this._patternName = patternName;
  }

  get name(): string {
    return this._name;
  }

  get patternName(): string {
    return this._patternName;
  }
}

class GoogleOptimizeExperiment {
  private readonly experiment: GoogleOptimizeExperimentData;

  constructor(experiment: GoogleOptimizeExperimentData) {
    this.experiment = experiment;
  }

  public init(): void {
    $(`[data-experiment-name='${this.experiment.name}']`).each((_index, element) => {
      const $element = $(element);
      if (this.isCurrentPattern($element)) {
        this.showPattern($element);
      } else {
        this.hidePattern($element);
      }
    });
  }

  private isCurrentPattern($element: JQuery): boolean {
    return $element.data("pattern-name") === this.experiment.patternName;
  }

  private hidePattern($element: JQuery): void {
    $element.remove();
  }

  private showPattern($element: JQuery): void {
    $element.css("opacity", 0);
    $element.removeClass("u-d-none");
    $element.animate(
      { opacity: 1 },
      {
        duration: 600,
        easing: 'linear',
      });
  }
}

export {
  GoogleOptimizeExperimentData,
  GoogleOptimizeExperiment,
};
